import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Icon ionic-md-mail-open-pink",
  "use": "icon-Icon ionic-md-mail-open-pink-usage",
  "viewBox": "0 0 31.5 27",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31.5 27\" id=\"icon-Icon ionic-md-mail-open-pink\"><defs><style>#icon-Icon ionic-md-mail-open-pink .a{fill:#ef7681;}</style></defs><path class=\"a\" d=\"M33.75,14.18a2.925,2.925,0,0,0-1.425-2.55L18,4.5,3.675,11.63A3.1,3.1,0,0,0,2.25,14.18V28.5a3.009,3.009,0,0,0,3,3h25.5a3.009,3.009,0,0,0,3-3ZM18,21.375,5.951,13.5,18,7.5l12.049,6Z\" transform=\"translate(-2.25 -4.5)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol